// extracted by mini-css-extract-plugin
export default {"content":"SK-z","lookName":"TK-z","shopTheLookContainer":"UK-z","productContainer":"VK-z","imageContainer":"WK-z","mainImage":"XK-z"};